import { render, staticRenderFns } from "./TekaComponent.vue?vue&type=template&id=39f87b61&xmlns=true&"
import script from "./TekaComponent.vue?vue&type=script&lang=js&"
export * from "./TekaComponent.vue?vue&type=script&lang=js&"
import style0 from "./TekaComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/neta-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39f87b61')) {
      api.createRecord('39f87b61', component.options)
    } else {
      api.reload('39f87b61', component.options)
    }
    module.hot.accept("./TekaComponent.vue?vue&type=template&id=39f87b61&xmlns=true&", function () {
      api.rerender('39f87b61', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/neta/neta-event/basic-data/forms/teka/TekaComponent.vue"
export default component.exports